import { useStore } from 'framework7-vue'

import Vehicles from '@/assets/classes/parking/Vehicles'
import { deleteVehicle } from '@/assets/composables/endpoints'
import { showPreloader } from '@/assets/composables/preloader'
import type { VehicleResponse } from '@/assets/composables/types'
import { notify, processError } from '@/assets/composables/utils'
import store from '@/js/store'

export default class Vehicle extends Vehicles {
  id: VehicleResponse['id']
  brand: VehicleResponse['brand']
  model: VehicleResponse['model']
  color: VehicleResponse['color']
  ecv: VehicleResponse['ecv']
  logoUrl: VehicleResponse['logoUrl']

  constructor(vehicle: VehicleResponse) {
    super()

    this.id = vehicle.id
    this.brand = vehicle.brand
    this.model = vehicle.model
    this.color = vehicle.color
    this.ecv = vehicle.ecv
    this.logoUrl = vehicle.logoUrl
  }

  async deleteVehicle() {
    const closePreloader = showPreloader('Odstraňujem vozidlo')
    try {
      await deleteVehicle(this.id)
      this.removeCurrentFromList()

      notify('Vozidlo bolo úspešne odstránené')
    } catch (error) {
      processError(error, 'Nepodarilo sa odstrániť vozidlo.')
      this.removeCurrentFromList()
      await Vehicles.fetchNewData()
    } finally {
      closePreloader()
    }
  }

  removeCurrentFromList() {
    const vehicles: Vehicle[] = useStore('vehicles').value

    const newVehicles = vehicles.filter((vehicle) => vehicle.id !== this.id)
    store.dispatch('setVehicles', newVehicles)
  }
}
